import axios from 'axios';

export const getSettings = async () => {
  const {
    data: { data },
  } = await axios.get(`/settings`);
  return {
    type: 'UPDATE_SETTINGS',
    data,
  };
};
